import React, { Component } from "react";
import { connect } from "react-redux";
import Dashboard from "../Dashboard/Dashboard";
import { MdThumbUp } from "react-icons/md";
import { assessmentActions } from "../../../_actions";


class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.getTalentTeenPattern());

  }

  render() {
    const { assessment } = this.props;
    const { getTalentTeenPatternData = {} } = assessment || {};
    const {
      reportData = {},
      topThemes = [],
      summary = "",
      list = [],
      studentName = "",
      assessmentDate = ""
    } = getTalentTeenPatternData;



    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }




    function groupDimensions(list) {
      const map = {};

      list.forEach(item => {
        const { bucket, dimension, colorCode, rank } = item;

        if (!map[bucket]) {
          map[bucket] = {
            bucket,
            dimensionList: []
          };
        }

        map[bucket].dimensionList.push({
          name: dimension,
          colorCode: colorCode,
          rank
        });
      });

      // Optional: sort dimensions by rank inside each bucket
      Object.values(map).forEach(group => {
        group.dimensionList.sort((a, b) => a.rank - b.rank);
      });

      return Object.values(map);
    }


    let bucketGroupList = groupDimensions(list);

    // ---------------- DERIVED DATA ----------------
    let pattern_list = [];
    let archetype_list = [];
    let job_roles_list = [];
    let fit_category = "";
    let score = 0;

    // Convert object → array
    const reportArray = Object.values(reportData || {})?.[0] || [];

    if (reportArray.length > 0) {
      reportArray.forEach(item => {
        if (item.pattern) {
          pattern_list.push(item.pattern);
        }

        if (item.archetype) {
          archetype_list.push(item.archetype);
        }

        if (Array.isArray(item.job_roles)) {
          job_roles_list.push(item.job_roles.join(" / "));
        }
      });

      // Take first item's values
      fit_category = reportArray[0]?.fit_category || "";
      score = Math.round(reportArray[0]?.score || 0);
    }




    // Prevent crash while loading
    if (!getTalentTeenPatternData || Object.keys(getTalentTeenPatternData).length === 0) {
      return (
        <Dashboard>
          <div className="p-10 text-center">Loading Report...</div>
        </Dashboard>
      );
    }

    return (
      <Dashboard>
        <div className="lg:w-[75%] w-full mx-auto overflow-hidden overflow-y-auto border">

          <section>
            <div className="py-10 space-y-10 bg-white ">
              <div className="flex flex-col items-center justify-between space-y-10 ">
                <div className="flex flex-col items-center space-y-8 text-center">
                  <div className="flex justify-center pt-2">
                    <img src="/img/assessment/TalentPlusStrengths_logo.svg" className="w-56" />
                  </div>
                  <div className="py-2 space-y-4 text-center">
                    <h1 className="text-6xl text-[#3D405B] font-normal text-center items-center justify-center uppercase">Student Career Fit Report</h1>
                    <h1 className="text-lg font-semibold text-[#212121]/85 italic">John Smith | 1 August, 2025</h1>
                  </div>
                  <div className="flex justify-center pt-6">
                    <img src="/admindashboard/CareerAssessment.png" className="w-full h-full mx-auto" />
                  </div>
                  <div className="text-center">
                    <p className="text-lg text-[#212121] font-medium">HappyPlus Online Assessments Copyright 2025</p>
                    <p className="text-base font-medium text-[#212121]/70 italic">This report is confidential and should not be distributed without permission</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="p-8 bg-white px-12">
            <div className="space-y-6">
              <div className="flex items-end justify-between w-full pt-4 pb-2 border-b text-[#212121]/85 italic">
                <h1 className="text-lg font-semibold">Career Assessment</h1>
                <p className="text-lg font-semibold">John Smith | 1 August, 2025
                </p>
              </div>

              <div class="w-full space-y-3">
                <h1 className="text-3xl font-light text-[#212121]">
                  <b>Assessment Summary</b>
                </h1>
                <p className="mt-2 text-sm textlight leading-relaxed">
                  This Career Fit Report is based on the TalentPlusStrengths Assessment, a structured and strength-based
                  career intelligence framework designed to evaluate job readiness and role alignment.
                </p>
              </div>

              <h2 className="text-2xl font-semibold textblack">Your Top 10 Themes</h2>

              <div className="mt-6 grid grid-cols-[160px_1fr_60px] text-sm font-semibold textblack">
                <div>Domains</div>
                <div>Themes</div>
                <div className="text-right">Rank</div>
              </div>


              <div className="space-y-3 text-sm">
                {bucketGroupList && bucketGroupList.length > 0 ? bucketGroupList.map((ele) =>
                  <div className="grid grid-cols-[160px_1fr_60px] items-center">
                    <div className="textblack font-medium">{ele.bucket}</div>
                    <div className="space-y-2 col-span-2">
                      {ele && ele.dimensionList && ele.dimensionList.length > 0 ? ele.dimensionList.map((inner) =>
                        <div style={{ background: hexToRgbA(inner.colorCode, "0.20") }} className="flex items-center justify-between rounded-lg bg-blue-100 px-4 py-2">
                          <span className="font-medium textblack">{inner.name}</span>
                          <span style={{ background: inner.colorCode }} className="ml-4 rounded-md  text-white text-xs font-semibold px-2 py-1">{inner.rank}</span>
                        </div>
                      ) : null}

                    </div>
                  </div>
                ) : null}


              </div>
            </div>

            <div className="mt-10 rounded-xl bg-gray-50 p-6">
              <h3 className="text-xl font-semibold textblack">Talent Interpretation</h3>
              <p className="text-sm textblack leading-relaxed">
                {summary || ""}
              </p>
            </div>
          </section>

          <section className="p-8 bg-white px-12 mb-10">
            <div className="flex items-end justify-between w-full pt-4 pb-2 border-b text-[#212121]/85 italic mb-6">
              <h1 className="text-lg font-semibold">Career Assessment</h1>
              <p className="text-lg font-semibold">John Smith | 1 August, 2025
              </p>
            </div>
            <div className="space-y-10">
              <div>
                <div className="grid grid-cols-2 gap-4 font-medium textblack">
                  <div className="flex flex-col">
                    <h2 className="text-2xl font-semibold textblack mb-3">Dominant Talent Pattern</h2>
                    <div className="bg-[#4CAF50]/10 px-4 py-2 rounded-md inline-block mb-2">Enterprise Leader</div>
                    <div className="bg-[#4CAF50]/10 px-4 py-2 rounded-md inline-block mb-2">Performance Leader</div>
                    <div className="bg-[#4CAF50]/10 px-4 py-2 rounded-md inline-block mb-2">Performance Leader</div>
                  </div>
                  <div className="flex flex-col">
                    <h2 className="text-2xl font-semibold textblack mb-3">Development Focus</h2>
                    <div className="bg-[#F44336]/10 px-4 py-2 rounded-md inline-block mb-2">Process Stabiliser</div>
                    <div className="bg-[#F44336]/10 px-4 py-2 rounded-md inline-block mb-2">Performance Leader</div>
                    <div className="bg-[#F44336]/10 px-4 py-2 rounded-md inline-block mb-2">Performance Leader</div>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-semibold textblack mb-3">Best-Fit Career Archetypes</h2>
                <div className="flex flex-wrap gap-3">
                  <p className="px-4 py-2 rounded-full bg-gray-100 font-medium textblack">Enterprise Leader</p>
                  <p className="px-4 py-2 rounded-full bg-gray-100 font-medium textblack">Finance & Risk Management</p>
                  <p className="px-4 py-2 rounded-full bg-gray-100 font-medium textblack">Quality, Compliance & Governance</p>
                  <p className="px-4 py-2 rounded-full bg-gray-100 font-medium textblack">Quality, Compliance & Governance</p>
                  <p className="px-4 py-2 rounded-full bg-gray-100 font-medium textblack">General Management</p>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-semibold textblack mb-3">Recommended Job Roles</h2>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center bg-[#4CAF50]/10 rounded-md p-3 space-x-3">
                    <MdThumbUp size={22} className="text-[#81C784]" />
                    <p className="textblack font-medium">Risk Analyst / Enterprise Risk Executive (Early Career)</p>
                  </div>
                  <div className="flex items-center bg-[#4CAF50]/10 rounded-md p-3 space-x-3">
                    <MdThumbUp size={22} className="text-[#81C784]" />
                    <p className="textblack font-medium">Compliance Executive / Governance Officer</p>
                  </div>
                  <div className="flex items-center bg-[#4CAF50]/10 rounded-md p-3 space-x-3">
                    <MdThumbUp size={22} className="text-[#81C784]" />
                    <p className="textblack font-medium">Operations Manager (Early Career)</p>
                  </div>
                  <div className="flex items-center bg-[#4CAF50]/10 rounded-md p-3 space-x-3">
                    <MdThumbUp size={22} className="text-[#81C784]" />
                    <p className="textblack font-medium">Finance Analyst</p>
                  </div>
                  <div className="flex items-center bg-[#4CAF50]/10 rounded-md p-3 space-x-3">
                    <MdThumbUp size={22} className="text-[#81C784]" />
                    <p className="textblack font-medium">Program Manager / PMO Analyst</p>
                  </div>
                </div>
              </div>

              <div class="space-y-4">
                <h2 class="text-2xl font-semibold textblack">Career Fit Score</h2>
                <div className="flex flex-col gap-2 w-full">
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-medium textblack">Strong Job Fit</span>
                    <span className="text-sm font-semibold textblack">80/100</span>
                  </div>
                  <div className="w-full h-6 rounded-md bg-[#DDDDDD] overflow-hidden">
                    <div className="h-full bg-red-500 rounded-md transition-all duration-700" style={{ width: `80%` }} />
                  </div>
                  <p className="textblack text-sm">This student shows a high probability of success in authority-driven, governance-heavy roles.</p>
                </div>
              </div>

              <div class="bg-gray-50 rounded-xl p-6">
                <p class="text-sm text-gray-600 leading-relaxed">This report should be used alongside academic performance and recruiter evaluations.</p>
              </div>

            </div>

          </section>

        </div>

      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  const { assessment } = state;
  return { assessment };
}

export default connect(mapStateToProps)(Report);
